import axios from 'axios'
import { useAuthStore } from '@/stores/AuthStore'

export default () => {
  const authStore = useAuthStore()
  var token = authStore.token
  return axios.create({ 
    baseURL: process.env.VUE_APP_GMW_API_URL,
    headers: {'Authorization': `Bearer ${token}`}
  })
}